import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgInfo = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.25 6C7.98478 6 7.73043 6.10536 7.54289 6.29289C7.35536 6.48043 7.25 6.73478 7.25 7V13C7.25 13.2652 7.35536 13.5196 7.54289 13.7071C7.73043 13.8946 7.98478 14 8.25 14C8.51522 14 8.76957 13.8946 8.95711 13.7071C9.14464 13.5196 9.25 13.2652 9.25 13V7C9.25 6.73478 9.14464 6.48043 8.95711 6.29289C8.76957 6.10536 8.51522 6 8.25 6ZM8.25 2C8.00277 2 7.7611 2.07331 7.55554 2.21066C7.34998 2.34801 7.18976 2.54324 7.09515 2.77165C7.00054 3.00005 6.97579 3.25139 7.02402 3.49386C7.07225 3.73634 7.1913 3.95907 7.36612 4.13388C7.54093 4.3087 7.76366 4.42775 8.00614 4.47598C8.24861 4.52421 8.49995 4.49946 8.72835 4.40485C8.95676 4.31024 9.15199 4.15002 9.28934 3.94446C9.42669 3.7389 9.5 3.49723 9.5 3.25C9.5 2.91848 9.3683 2.60054 9.13388 2.36612C8.89946 2.1317 8.58152 2 8.25 2Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgInfo)
const IconSvgInfo = createIcon(ForwardRef, 'SvgInfo')
export default IconSvgInfo
